export function sanitizeRedirectPath(
  redirect: string | null | undefined,
): string | undefined {
  if (!redirect) return undefined

  const placeholderOrigin = 'https://placeholder.invalid'
  try {
    const url = new URL(redirect, placeholderOrigin)
    if (url.origin !== placeholderOrigin) return undefined
    const path = `${url.pathname}${url.search}${url.hash}`
    if (!path.startsWith('/') || path.startsWith('//')) return undefined
    return path
  } catch {
    return undefined
  }
}
